// @flow
import $ from 'jquery';
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
import dayjs from 'dayjs';
// $FlowFixMe
import Settings from '../../../../application/config/settings.js.erb';

export default class FormView extends JQueryView {
  constructor() {
    super('.simple_form');
    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });
    this.render();
  }

  @on({
    event: 'change',
    selector:
      'input[name="officer_approval_stockholder_meeting[meeting_type]"]',
  })
  onChangeMeetingTypes() {
    this.meetingTypeFormToggle();
  }

  @on({
    event: 'change',
    selector:
      'input[name="officer_approval_stockholder_meeting[is_pdf_document]"]',
  })
  onChangeIsPdfDocument() {
    this.render();
  }

  @on({
    event: 'change',
    selector:
      'input[name="officer_approval_stockholder_meeting[pdf_document]"]',
  })
  onChangeJaPdfDocument(event: any) {
    this.onChangePdfDocument(event);
  }

  @on({
    event: 'change',
    selector:
      'input[name="officer_approval_stockholder_meeting[english_pdf_document]"]',
  })
  onChangeEnglishPdfDocument(event: any) {
    this.onChangePdfDocument(event);
  }

  @on({ event: 'click', selector: '#delete-english-pdf-document' })
  onClickDeleteEnglishPdfDocument() {
    $('.uploaded-english-pdf-document').hide();
    $('#delete_english_pdf_document').val(true);
  }

  generateSelectedFilesHtml = (key: string, file: any) => `
    <p class="m-0 p-2">${file.name}</p>
  `;

  @on({ event: 'keydown', selector: '.date-field' })
  preventTypingDate(event: any) {
    const key = event.keyCode;
    if (key === 8) {
      $(event.currentTarget).val('');
    }
    return false;
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field1') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  @on({ event: 'click', selector: '.input-group-append' })
  onClickAppend(event: any) {
    $(event.target)
      .parents('.input-group')
      .children('input,.daterange-picker')
      .focus();
  }

  initBaseAtDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  initStartAtDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        timePicker: true,
        timePicker24Hour: true,
        showDropdowns: true,
        minDate: dayjs(),
        startDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD HH:mm',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD HH:mm',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  showAttachmentDocumentForm() {
    const isPdfDocument = $(
      'input[name="officer_approval_stockholder_meeting[is_pdf_document]"]',
    )
      .filter(':checked')
      .val();
    if (isPdfDocument == 'true') {
      $('.pdf_document_form').show();
    } else {
      $('.pdf_document_form').hide();
    }
  }

  meetingTypeFormToggle() {
    const meetingType = $(
      'input[name="officer_approval_stockholder_meeting[meeting_type]"]',
    )
      .filter(':checked')
      .val();
    if (meetingType == 'periodic') {
      $('.meeting_times_form').show();
      $('.classified_form').hide();
    } else if (meetingType == 'classified') {
      $('.meeting_times_form').hide();
      $('.classified_form').show();
    } else {
      $('.meeting_times_form').hide();
      $('.classified_form').hide();
    }
  }

  onChangePdfDocument(event: any) {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileSizeMB = selectedFile.size / (1024 * 1024);
      if (fileSizeMB > Settings.officerApprovals.maxFileSize / (1024 * 1024)) {
        alert('30MB以下のファイルを選択してください。');
        event.target.value = '';
      }
    }
  }

  render() {
    this.meetingTypeFormToggle();
    this.showAttachmentDocumentForm();

    const baseAtForm = $('.officer_approval_stockholder_meeting_base_on');
    const startAtForm = $('.officer_approval_stockholder_meeting_start_at');
    const VotingDeadlineForm = $(
      '.officer_approval_stockholder_meeting_voting_deadline',
    );
    this.initBaseAtDateRangePicker(baseAtForm);
    this.initStartAtDateRangePicker(startAtForm);
    this.initStartAtDateRangePicker(VotingDeadlineForm);
  }
}
